export enum UserRoleEnum {
  sales = 'sales',
  acquisition = 'acquisition',
  operations = 'operations',
  tech = 'tech',
  product = 'product',
}

export interface UserProps {
  id: number
  email: string
  taxStatus: string
  taxSituation: string
  name: string
  phone: string
  profile: string
  isActive: boolean
  allowEmail: boolean
  allowWhatsapp: boolean
  team: keyof typeof UserRoleEnum
}

export interface UserListWithPagesProps {
  count: number
  next: string | null
  previous: string | null
  results: UserProps[]
}
